export default {
    charities: {
        charitableGiving: '慈善捐贈',
        charities: '慈善機構',
        profileTitleSuffix: '精選慈善機構',
        donateToday: '立即捐款',
        visitWebsite: '前往慈善機構網站',
        backToFeaturedCharities: '返回精選慈善機構',
        heroEyebrow: '讓心意延續',
        heroTitle: '為你關心的慈善組織留下心意',
        heroBody: '你的平安紙既可照顧摯愛，也可支持你重視的慈善組織。NobleWills 協助你在遺產規劃中清楚記錄慈善捐贈意願。',
        heroImageAlt: '三名義工在社區中心一起準備關懷物資包',
        startWill: '開始訂立平安紙',
        meetPartners: '認識我們的精選慈善機構',
        howEyebrow: '如何安排',
        howTitle: '三個簡單步驟加入慈善捐贈',
        howBody: '要在平安紙中留下慈善捐贈，你可選擇心儀的慈善機構、決定留下固定金額或剩餘遺產的一部分，並在平安紙中清楚記錄機構及捐贈詳情。',
        step1Title: '選擇慈善組織',
        step1Body: '你可指定任何重視的慈善機構，並不限於 NobleWills 精選的慈善機構。',
        step2Title: '選擇捐贈方式',
        step2Body: '你可留下固定金額，或在處理其他饋贈及責任後，捐出剩餘遺產的一部分。',
        step3Title: '記錄於平安紙',
        step3Body: '在訂立平安紙時加入慈善機構及捐贈詳情，並在完成前仔細核對。',
        giftTypesEyebrow: '捐贈選項',
        giftTypesTitle: '簡單了解固定金額及剩餘遺產捐贈',
        giftTypesBody: '合適的方式取決於你希望捐贈達到的目的，以及你打算如何分配其餘遺產。',
        fixedGiftTitle: '固定金額捐贈',
        fixedGiftBody: '在平安紙中指定一筆確實金額，留給你選擇的慈善機構。',
        residuaryGiftTitle: '剩餘遺產捐贈',
        residuaryGiftBody: '在處理債務、開支、稅項及其他饋贈後，將剩餘遺產的某個百分比或份額留給慈善機構。',
        giftExampleLabel: '說明例子',
        fixedGiftExample: '港幣{{amount}}元',
        residuaryGiftExample: '剩餘遺產的5%',
        giftExampleDisclaimer: '這並非法律、稅務或財務建議。',
        giftFlexibility: '無論選擇哪種方式，請清楚註明慈善機構的名稱；如你的意願或機構資料有變，亦應適時更新平安紙。',
        taxNote: '稅務處理會因司法管轄區及個人情況而異。如稅務因素與你的安排有關，請考慮向合資格的稅務顧問查詢。',
        localPartnersEyebrow: '立足本地',
        localPartnersTitle: '{{location}}精選慈善機構',
        localPartnersBody: '認識在你所屬社區服務的精選慈善機構。',
        worldwidePartnersEyebrow: '連繫各地',
        worldwidePartnersTitle: '全球精選慈善機構',
        worldwidePartnersBody: '認識 NobleWills 社群在不同地方的其他精選機構。',
        learnMore: '進一步了解{{charity}}',
        partnerStripTitle: '遍布全球的慈善夥伴',
        partnerStripBody: '認識為人群、動物、社區及環境帶來改變的機構。',
        partnerStripCta: '了解慈善捐贈',
        recruitmentEyebrow: '慈善機構合作',
        recruitmentTitle: '讓更多支持者的心意得以延續',
        recruitmentBody: '我們與慈善機構合作，讓大眾更容易了解遺產捐贈並記錄意願。歡迎查詢如何成為 NobleWills 慈善夥伴。',
        recruitmentCta: '查詢合作詳情',
        recruitmentFallback: '或聯絡我們的團隊',
        recruitmentMessage: '你好，我代表一間慈善機構，希望了解如何成為 NobleWills 的慈善夥伴。',
        faqEyebrow: '常見問題',
        faqTitle: '慈善捐贈常見問題',
        faq1Question: '我可否把捐贈留給此頁沒有列出的慈善機構？',
        faq1Answer: '可以。頁內精選慈善機構只供參考，你可指定其他對你重要的慈善機構。',
        faq2Question: '固定金額捐贈與剩餘遺產捐贈有何分別？',
        faq2Answer: '固定金額捐贈是指定一筆確實金額；剩餘遺產捐贈則是在處理債務、開支、稅項及其他饋贈後，捐出剩餘遺產的某個百分比或份額。',
        faq3Question: '我應提供哪些慈善機構資料？',
        faq3Answer: '請使用慈善機構現時的法定名稱，並在可行情況下提供註冊編號及地址。清楚的資料有助遺囑執行人識別你指定的機構。',
        faq4Question: '日後可否更改慈善捐贈？',
        faq4Answer: '可以。如你的意願或情況有變，請重新檢視平安紙，並按照適用於你的簽署規定作出更新。',
        faq5Question: '慈善捐贈會否減少遺產稅項？',
        faq5Answer: '稅務處理會因司法管轄區及個人情況而異。如稅務因素與你的安排有關，請考慮向相關司法管轄區的合資格稅務或法律顧問查詢。',
        finalEyebrow: '讓心意實現',
        finalTitle: '準備好在平安紙中支持你關心的慈善組織？',
        finalBody: '開始訂立平安紙，記錄你希望照顧的人及支持的慈善組織。',
    },
};
